import { render, staticRenderFns } from "./NavBarButton.vue?vue&type=template&id=5f10b746&"
import script from "./NavBarButton.vue?vue&type=script&lang=ts&"
export * from "./NavBarButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports